module.exports = __webpack_public_path__ + "static/media/laptop.25d30d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/laptop.svg
// module id = 285
// module chunks = 0